import { render, staticRenderFns } from "./common-free-video.vue?vue&type=template&id=4b8c4be8&scoped=true&"
import script from "./common-free-video.vue?vue&type=script&lang=js&"
export * from "./common-free-video.vue?vue&type=script&lang=js&"
import style0 from "./common-free-video.vue?vue&type=style&index=0&id=4b8c4be8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../src/h5-coursePage/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b8c4be8",
  null
  
)

export default component.exports